module.exports = __webpack_public_path__ + "static/media/RealisedRateTermsAndConditions.1ec10f0e.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/static/RealisedRateTermsAndConditions.pdf
// module id = 188
// module chunks = 0